// 4px grid spacing system
export const SPACING = {
  xxs: 2, // Micro spacing (borders, fine adjustments)
  xs: 4, // Tight spacing
  sm: 8, // Small gaps
  smd: 12, // Between sm and md
  md: 16, // Standard padding
  lg: 24, // Section spacing
  xl: 32, // Large gaps
  xxl: 48, // Screen-level spacing
} as const;

export type SpacingKey = keyof typeof SPACING;
export type SpacingValue = (typeof SPACING)[SpacingKey];
